// Typy biura podawczego — przesyłki wychodzące: kategorie/zakładki, karty nadawcze
// (DispatchChart) i zwrotki ZPO. Odwzorowanie modułu wychodzących z Magistratu.

import { IKey } from "dto/IKey";

/** Kategoria formy doręczenia (BE ParcelDeliveryCategory) — steruje zakładką. */
export enum EParcelDeliveryCategory {
  Post = 0,
  PersonalPickup = 1,
  PersonalDelivery = 2,
  EDelivery = 3,
  Epuap = 4,
  Email = 5,
  Courier = 6,
}

/** Podgrupa Poczty (BE ParcelPostGroup) — polecone/ZPO vs zwykłe. */
export enum EParcelPostGroup {
  RegisteredZpo = 0,
  Plain = 1,
}

export interface IOutgoingPostGroup {
  PostGroup: number;
  Name: string;
  Count: number;
  DeliveryKindIds: number[];
}

export interface IOutgoingCategory {
  Category: number;
  Name: string;
  SupportsDispatchChart: boolean;
  SupportsReceptionConfirmation: boolean;
  ReadyToDispatchCount: number;
  ChartCount: number;
  PendingReceptionCount: number;
  DeliveryKindIds: number[];
  PostGroups: IOutgoingPostGroup[];
}

export interface IOutgoingCategoriesResponse {
  Categories: IOutgoingCategory[];
}

export interface IDispatchListItem {
  Id: string;
  ParcelNumber?: string | null;
  Title?: string | null;
  ReceiverName?: string | null;
  ReceiverAddress?: string | null;
  DeliveryKindId?: number | null;
  DeliveryKindName?: string | null;
  CaseSignature?: string | null;
  DocumentDate?: string | null;
  EditorDocumentId?: string | null;
  AuthorName?: string | null;
}

export interface IDispatchListResponse {
  Items: IDispatchListItem[];
  IsTeamView: boolean;
}

export interface IDispatchChartParcel {
  Id: string;
  ParcelNumber?: string | null;
  Title?: string | null;
  ReceiverName?: string | null;
  ReceiverAddress?: string | null;
  Fee?: number | null;
  AuthorName?: string | null;
}

export interface IDispatchChart {
  Id: string;
  Signature: string;
  DeliveryKindId: number;
  DeliveryKindName?: string | null;
  ChartTypeCode?: string | null;
  Number: number;
  Year: number;
  CreationDate: string;
  DispatchDate?: string | null;
  IsFake: boolean;
  ParcelCount: number;
  CreatorName?: string | null;
  SenderName?: string | null;
  Parcels: IDispatchChartParcel[];
}

export interface IDispatchChartListResponse {
  Charts: IDispatchChart[];
  IsTeamView: boolean;
}

export interface IPendingReceptionItem {
  Id: string;
  ParcelNumber?: string | null;
  Title?: string | null;
  ReceiverName?: string | null;
  DispatchDate?: string | null;
  DeliveryKindId?: number | null;
  AuthorName?: string | null;
}

export interface IPendingReceptionResponse {
  Items: IPendingReceptionItem[];
  IsTeamView: boolean;
}

// ── Requesty ──

export interface IDispatchListRequest {
  Category: number;
  PostGroup?: number | null;
}

export interface IPrepareDispatchChartRequest {
  ParcelIds: string[];
  SendDate?: string | null;
  IsFake: boolean;
}

export interface IPrepareDispatchChartResponse {
  ChartId: string;
  Signature: string;
}

export interface IProcessDispatchChartRequest {
  ChartId: string;
  DispatchDate: string;
  DispatchNoteFileUri?: string | null;
  DispatchNoteKeyId?: string | null;
}

export interface IDispatchChartListRequest {
  Category?: number | null;
  IncludeDispatched?: boolean;
}

export interface IRemoveFromChartRequest {
  ChartId?: string | null;
  ParcelIds?: string[] | null;
}

export interface IReceptionConfirmationRequest {
  ParcelId: string;
  ReceptionDate: string;
  IsReturned: boolean;
  ReturnAnnotation?: string | null;
  ScanFileUri?: string | null;
  ScanKeyId?: string | null;
}

export interface IPendingReceptionRequest {
  Category?: number | null;
}

export interface IResendParcelRequest {
  ParcelId: string;
}

export interface IResendParcelResponse {
  NewParcelId: string;
  ParcelNumber?: string | null;
}

// Status przesyłek wygenerowanych z pisma (widok Dysku / CaseDossier).
export enum EParcelDispatchStage {
  ReadyToDispatch = 0,
  InChart = 1,
  Sent = 2,
  Received = 3,
  Returned = 4,
}

export interface IDocumentParcel {
  Id: string;
  ParcelNumber?: string | null;
  ReceiverName?: string | null;
  DeliveryKindName?: string | null;
  Stage: number;
  StageLabel: string;
  DispatchDate?: string | null;
  ReceivedDate?: string | null;
}

export interface IDocumentParcels {
  HasParcels: boolean;
  MajorSignature?: string | null;
  Parcels: IDocumentParcel[];
}

// Podgląd treści przesyłki (wygenerowane pismo / PDF) — plik + klucze do deszyfrowania.
export interface IParcelPreview {
  Uri: string;
  EncryptionKeyId: string | null;
  Kind: number;
  FileName?: string | null;
  ObjectKeys: IKey[];
  Keys: IKey[];
}
